export default __webpack_public_path__ + "static/media/pan-flag.4384820e.svg";